import { TFunction } from 'i18next'
import axios from '../axios'
import { logError } from 'shared'
import { getHeadersWithJwtToken } from 'auth/utils/auth-util'
import appConfig from 'app.config'

async function updateMarketingConsentService(
	partyId: string,
	allowMarketingConsent: boolean,
	t: TFunction,
) {
	const requestData = {
		partyId,
		allowMarketingConsent,
	}

	try {
		const response = await axios.post(
			`${appConfig.customerDataBaseUrl}/api/user/marketingconsent/update`,
			requestData,
			await getHeadersWithJwtToken(),
		)

		if (response.status === 200) {
			return { status: response.status, statusText: response.statusText }
		} else {
			throw new Error(t('ErrorMsg'))
		}
	} catch (error: any) {
		logError(error)
		if (error.response) {
			throw new Error(t('ErrorMsg'))
		} else if (error.request) {
			throw new Error(t('NetworkError'))
		} else {
			throw new Error(t('UnexpectedError'))
		}
	}
}

export default updateMarketingConsentService
